module.exports = __webpack_public_path__ + "media/promo/courses/images/s4-11286c31856f954f48dd1e96f6666be7.jpg";